import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

export interface ICreateThreadMessageRequestAction {
  data: {
    text: string;
    threadMessageId: number;
  };
  functions: {
    closeModal: () => void;
    error: (err: any) => void;
  };
}

function createThreadMessageRequest(
  draft: Draft<IInterventionData>,
  _: PayloadAction<ICreateThreadMessageRequestAction>,
) {
  draft.createThreadMessage.config.isLoading = true;
}

export default createThreadMessageRequest;
